class PaymentMethod {
    constructor(cc_name='', cc_num='', cc_month='', cc_year='', cc_cvv2='', cur_year=new Date().getFullYear(), url=`ajax/instance_payment_method/`, payment_profile='', type='', include_address=true, parent_container='.cc_cont' ) {
        this.cc_name = cc_name;
        this.cc_num = cc_num;
        this.cc_month = cc_month;
        this.cc_year = cc_year;
        this.cc_cvv2 = cc_cvv2;
        this.cur_year = cur_year;
        this.url = url;

        this.payment_profile = payment_profile;
        this.type = type;
        this.include_address = include_address;
        this.parent_container = parent_container;

        this._debug = {
            // build_card_payment: true,
            update_instance_payment_method: {
                pre: true,
                post: true,
            },
            // add_card: true,
            // validate_card: {
                // all: true,
                // validate_cc_name: true,
                // validate_cc_num: true,
                // validate_cc_exp: true,
                // validate_cc_cvv: true,
            // },
        }
    }

 
    _methods = { // ----------------------- Start Methods -----------------
        _setters: { // ----------------------- Start - Setters -------------------
            set_cc_name: (cc_name) => this.cc_name = cc_name,
            set_cc_num: (cc_num) => this.cc_num = cc_num,
            set_cc_month: (cc_month) => this.cc_month = cc_month,
            set_cc_year: (cc_year) => this.cc_year = cc_year,
            set_cc_cvv2: (cc_cvv2) => this.cc_cvv2 = cc_cvv2,
            set_cur_year: (cur_year) => this.cur_year = cur_year,
            set_url: (url) => this.url = url,
            set_payment_profile: (payment_profile) => this.payment_profile = payment_profile,
            set_type: (type) => this.type = type,
            set_include_address: (include_address) => this.include_address = include_address,
            set_parent_container: (parent_container) => this.parent_container = parent_container,
            set_card_data: (data) => {
                const _setters = this._methods._setters;
                data.cc_name ?? _setters.set_cc_name(data.cc_name);
                data.cc_num ?? _setters.set_cc_num(data.cc_num);
                data.cc_month ?? _setters.set_cc_month(data.cc_month);
                data.cc_year ?? _setters.set_cc_year(data.cc_year);
                data.cc_cvv2 ?? _setters.set_cc_cvv2(data.cc_cvv2);
                data.cur_year = _setters.set_cur_year(data.cur_year);
                data.url ?? _setters.set_url(data.url);
                data.payment_profile ?? _setters.set_payment_profile(data.payment_profile);
                data.type ?? _setters.set_type(data.type);
                data.include_address ?? _setters.set_include_address(data.include_address);
                data.set_parent_container ?? _setters.set_parent_container(data.parent_container);
            },
        }, // ----------------------- End - Setters -------------------   
        _getters: { // ----------------------- Start - Getters -------------------
            get_all_cc_inputs: () => {
                const _getters = this._methods._getters;

                this.cc_name = _getters.get_cc_name();
                this.cc_num = _getters.get_cc_num();
                this.cc_month = _getters.get_cc_month();
                this.cc_year = _getters.get_cc_year();
                this.cc_cvv2 = _getters.get_cc_cvv();
                this.payment_profile = _getters.get_payment_profile();
                // this.type = _getters.get_type();
            },
            get_cc_name: ( custom=false ) => {
                if(!custom)
                    var val = am.$('#cc_name').val();
                else
                    var val = am.$(custom).val();
        
                return val == undefined ? '' : val;
            },
            get_cc_num: ( custom=false ) => {
                if(!custom)
                    var val = am.$('#cc_num').val();
                else
                    var val = am.$(custom).val();
        
                return val == undefined ? '' : val;
            },
            get_cc_month: ( custom=false ) => {
                if(!custom)
                    var val = am.$('#exp_month').val();
                else
                    var val = am.$(custom).val();
        
                return val == undefined ? '' : val;
            },
            get_cc_year: ( custom=false ) => {
                if(!custom)
                    var val = am.$('#exp_year').val();
                else
                    var val = am.$(custom).val();
                
                return val == undefined ? '' : String(this._methods._getters.get_year()).substring(0, 2) + val;
            },
            get_cc_cvv: ( custom=false ) => {
                if(!custom)
                    var val = am.$('#cc_cvv2').val();
                else
                    var val = am.$(custom).val();
        
                return val == undefined ? '' : val;
            },
            get_payment_profile: ( custom=false ) => {
                if(!custom)
                    var val = am.$('#payment_profile').val();
                else
                    var val = am.$(custom).val();
        
                return val == undefined ? '' : val;
            },
            get_year: () => {
                const currentYear = new Date().getFullYear();
                return currentYear;
            },
            get_card_data: () => {
                const _getters = this._methods._getters;
                _getters.get_all_cc_inputs();
            },
        }, // ----------------------- End - Getters -------------------
        _helpers: {
            add_card: () => {
                this._methods._getters.get_card_data();
                if(this._debug.add_card)
                    console.log(this._methods._validators.validate_card(), "this._methods._validators.validate_card()");

                if(this._methods._validators.validate_card())
                    return true;
            },
            update_instance_payment_method: () => {
                this._methods._getters.get_all_cc_inputs();

                show_loading_svg();
                var address = new Address();
                var data = {
                    type: this.type,
                    cc_num: this.cc_num,
                    cc_month: this.cc_month,
                    cc_year: this.cc_year,
                    cc_cvv2: this.cc_cvv2,
                    cc_name: this.cc_name,
                    payment_profile: this.payment_profile,
                    address: address._methods._getters._ui.get_all_values(am.$('.address-section')),
                    sandbox_signup: this.type == 'update' ? 0 : 1
                }
        
                if(this._debug.update_instance_payment_method.pre)
                    console.log(this, data, "this/data - update_instance_payment_method - pre");

                try{
                    am.$.ajax({
                        type : 'POST',
                        url: this.url,
                        data: data,
                        success: function(res) {
                            hide_loading_svg();
                            var parsed = JSON.parse(res);

                            if(parsed.failed){
                                var stripError = new StripeErrorHandling(parsed.error);
                                    stripError.show_error(); 
                            }
                            else if(parsed.sandbox_signup){
                                unbind_is_dirty_e('card_cont');
                                add_success_msg_to_storage_for_refresh(get_language_translation('LANG_SUCCESS_MSG_PAYMENT_SUCCESSFUL'));
                                setTimeout(()=> { 
                                    unbind_is_dirty_e('card_cont') // remove beforeUnload used to watch form 
                                    location.reload();
                                }, 500);
                            }
                            else{
                                var card = new PaymentMethod();
                                    card._methods._builders.build_card_payment(parsed);
        
                    
                                if(am.$('#needs_payment').length > 0){
                                    add_success_msg_to_storage_for_refresh(get_language_translation('LANG_MSG_CARD_SAVED_SUCCESSFULLY'));
                                    setTimeout(()=> { 
                                        unbind_is_dirty_e('card_cont') // remove beforeUnload used to watch form 
                                        location.reload(); 
                                    }, 500);
                                }
                                else{
                                    show_snackbar({
                                        message: get_language_translation('LANG_MSG_CARD_SAVED_SUCCESSFULLY'),
                                        type: 'success',
                                        timer: 4000
                                    });
                                }
                            }
                        },
                        failure: function(res) {
                            hide_loading_svg();
                            show_snackbar({
                                message: res.JSON.responseText + '.',
                                type: 'danger',
                                timer: 4000
                            });
                        }
                    });
                }catch(e){
                    console.log(e);
                }

                if(this._debug.update_instance_payment_method.post)
                    console.log(this, "this - update_instance_payment_method - post");
            },
            toggle_disabled_btn: () => {
                set_input_state('card_cont', true);
            }
        },
        _builders: { // ----------------------- Start - Builders -------------------
            build_card_payment: (data) =>{
                if(!data || !data.data)
                    var dne = true;
                else
                    data = data.data;
            
                let btn;
                if(dne){
                    var expired_warning = '';
                    var classes = { card_block: 'am-card-block-missing', existing: '' };
                    var inputs = { 
                        name: { value: '', disabled: ''}, 
                        number: { value: '', disabled: ''}, 
                        exp_month: { value: '', disabled: ''}, 
                        exp_year: { value: '', disabled: ''}, 
                        cvv2: { value: '', disabled: ''} 
                    };
            
                    if(am.$('#needs_payment').length > 0){ 
                        console.log("needs payment");
                        if(am.$('#new_customer').length > 0){ 
                            console.log("new cutsomer"); // New customer signup
                            btn = `<button id="get-started-btn" type="button" class='am-btn am-btn--filled me-lg-0' onclick="add_payment_method('signup', ' modals/instance_signup/ ')" disabled> ${get_language_translation('LANG_LABEL_GET_STARTED')}</button>`;
                        } 
                        else{ 
                            console.log("existing cutsomer"); // existing customer / account settings page btn to add new payment method
                            btn = `<button id="get-started-btn" type="button" class="d-block am-btn am-btn--filled" onclick="add_payment_method('new', ' modals/instance_signup/ ' )" disabled>${get_language_translation('LANG_BTN_SUBMIT')}</button>`;
                        }
                    }
                    else if(am.$('#payment_profile').length > 0){
                        console.log("update allmoxy subscription");
                        btn = `<button id="get-started-btn" type="button" class="am-btn am-btn--filled" onclick="add_payment_method('update', ' modals/instance_signup/ ')" disabled> Update Payment</button>`;
                    }
                    else{ 
                        console.log("fallback btn "); // account settings page btn
                        btn = `<button id="get-started-btn" type="button" class='am-btn am-btn--filled me-lg-0' onclick="add_payment_method('signup', ' modals/instance_signup/ ')" disabled> ${get_language_translation('LANG_LABEL_GET_STARTED')}</button>`;
                    } 
                }
                else{
                    if(data.card_expired)
                        var expired_warning = `<div id="expired_card_alert" class="am-alert am-alert--danger" style="margin: 17px 16px 33px;">This card has expired.<a class="blue-text" onclick="toggle_card_view('update')"> Click here </a>to add a new one.</div>`;
                    else
                        var expired_warning = '';
                    
                    var classes = { card_block: 'am-card-block-existing', existing: 'existing-card'};
                    var inputs = { 
                        name: { value: data.name, disabled: ' disabled '}, 
                        number: { value: 'xxxxxxxxxxxx' + data.last4, disabled: ' disabled '}, 
                        exp_month: { value: data.exp_month, disabled: ' disabled '}, 
                        exp_year: { value: data.exp_year.slice(2,4), disabled: ' disabled '}, 
                        cvv2: { value: '', disabled: ' disabled '} 
                    };
            
                    // account settings page btn when expired 
                    btn = `<button id="add_new_card" type="button" class="am-btn am-btn--filled" onclick="add_new_card(false, ' ${this.parent_container} ')">${get_language_translation('LANG_LABEL_ADD_NEW_CARD')}</button>`;
                }
            
                if(data.accepts_amex || data.gateway_type != 'authnet'){
                    var brands = `
                        <img class="visa ${data.cc_brand == 'Visa' ? ' visible ' : ''} " src="https://cdn.allmoxy.com/mrp/images/svg/visa_logo.svg">
                        <img class="mastercard ${data.cc_brand == ' Mastercard ' || data.cc_brand == 'MasterCard' ? 'visible' : ''} " src="https://cdn.allmoxy.com/mrp/images/svg/mastercard_logo.svg">
                        <img class="discover ${data.cc_brand == ' Discover ' ? 'visible' : ''} " src="https://cdn.allmoxy.com/mrp/images/svg/discover_logo.svg"> 
                        <img class="amex ${data.cc_brand == ' amex ' || data.cc_brand == 'American Express' ? 'visible' : ''} " src="https://cdn.allmoxy.com/mrp/images/svg/amex_logo.svg">
                    `;
                }else{
                    var brands = `
                        <img class="visa ${data.cc_brand == 'Visa' ? ' visible ' : ''} " src="https://cdn.allmoxy.com/mrp/images/svg/visa_logo.svg">
                        <img class="mastercard ${data.cc_brand == 'Mastercard' || data.cc_brand == 'MasterCard' ? ' visible ' : ''} " src="https://cdn.allmoxy.com/mrp/images/svg/mastercard_logo.svg">
                        <img class="discover ${data.cc_brand == 'Discover' ? ' visible ' : ''} " src="https://cdn.allmoxy.com/mrp/images/svg/discover_logo.svg">
                    `;
                }
            
                var $card_block = am.$(`
                ${expired_warning}
                    <div class="am-card-block ${classes.card_block}">
                        <div class="am-sectionParent js-cc_name_section ${classes.existing}">
                            <div class="am-section-row">
                                <label class="am-section-label" for="cc_name">
                                    ${get_language_translation('LANG_LABEL_NAME_ON_CARD')}
                                </label>
                                <input class="am-section-input js-required js-cc-name" type="text" name="cc_name" id="cc_name" value="${inputs.name.value}" ${inputs.name.disabled} />
                            </div>
                        </div>
                        <div class="am-sectionParent card-number js-cc_num_section ${classes.existing}">
                            <div class="am-section-row">
                                <label class="am-section-label" for="cc_num">
                                    ${get_language_translation('LANG_CARD_NUMBER')}
                                </label>
                                <div class="am-sectionParent js-brands-cont-mobile">
                                    <div class="cc-brands">
                                        <img src="https://cdn.allmoxy.com/mrp/images/svg/visa_logo.svg">
                                        <img src="https://cdn.allmoxy.com/mrp/images/svg/mastercard_logo.svg">
                                        <img src="https://cdn.allmoxy.com/mrp/images/svg/discover_logo.svg">
                                        <img src="https://cdn.allmoxy.com/mrp/images/svg/amex_logo.svg">
                                    </div>
                                </div>
                                <span class="card-number ${classes.existing}">
                                    <input class="am-section-input js-required js-validate-cc-number" type="text" name="cc_num" id="cc_num" value="${inputs.number.value}" ${inputs.number.disabled} minlength="16" maxlength="16" />
                                    <i class="fas fa-eye" onclick="toggle_num(event);"></i>
                                    ${brands}
                                </span>
                            </div>
                        </div>
                        <div class="am-sectionParent js-cc_exp_section ${classes.existing}">
                            <div class="am-section-row">
                                <label class="am-section-label" for='exp_month'>
                                    ${get_language_translation('LANG_LABEL_EXPIRATION_DATE')}
                                </label>
                                <div id="am-exp-date-cont" class="${classes.existing}">
                                    <span class="dates">
                                        <input class="js-required js-cc_exp_month" type="text" name="expiration_date" id="exp_month" value="${inputs.exp_month.value}" ${inputs.exp_month.disabled}  placeholder="MM" size="2" maxLength="2" onkeydown="allow_numbers_only(event)" onkeyup="jump_to_year(event)"/>
                                        <span>/</span>
                                        <input class="js-required js-cc_exp_year" type="text" name="expiration_date" id="exp_year" value="${inputs.exp_year.value}" ${inputs.exp_year.disabled} placeholder="YY" size="2" maxLength="2" onkeydown="jump_to_month(event)" />
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="am-sectionParent js-cc_cvv2_section ${classes.existing}">
                            <div class="am-section-row">
                                <label class="am-section-label cvv" for="cc_cvv2">
                                    ${get_language_translation('LANG_LABEL_CVV2_CODE')}
                                    <button id="cvv_btn" type="button" class="noprint fas fa-info-circle am-tooltipIcon"
                                     tabindex="-1" data-bs-custom-class="am-tooltip-body am-tooltip-body--cvv2"
                                      data-bs-trigger="focus" data-bs-html="true" data-bs-placement="top"
                                       data-bs-toggle="tooltip" 
                                       title="<span>${get_language_translation('LANG_TOOLTIP_CVV_MSG')} <img src='https://cdn.allmoxy.com/mrp/images/svg/cvv_identifier.svg'> </span>" 
                                       data-bs-offset="0,10"></button>
                                </label>
                                <input type="text" class="am-section-input js-required js-cc-cvv2" name="cc_cvv2"
                                 id="cc_cvv2" value="" size="4" maxLength="4" />
                            </div>
                        </div>
                        <div class="am-sectionParent js-brands-cont-desktop">
                            <div class="card-brands">
                                <img src="https://cdn.allmoxy.com/mrp/images/svg/visa_logo.svg">
                                <img src="https://cdn.allmoxy.com/mrp/images/svg/mastercard_logo.svg">
                                <img src="https://cdn.allmoxy.com/mrp/images/svg/discover_logo.svg">
                                <img src="https://cdn.allmoxy.com/mrp/images/svg/amex_logo.svg">
                            </div>
                        </div>

                        <div class="am-sectionParent js-address-wrapper"></div>

                        <div class="am-sectionParent js-cta-btns">
                            <div class="am-button-row am-button-row--right">
                                ${btn}
                            </div>
                        </div>
                    </div>
                `);

                if(am.$(this.parent_container).children('.am-card-block').length > 0){
                    am.$(this.parent_container).children('.am-card-block').replaceWith($card_block);
                }
                else{
                    am.$(this.parent_container).append($card_block);
                }

                try{
                    if(this.include_address && classes.card_block == 'am-card-block-missing'){
                        const $wrapper = am.$('.js-address-wrapper');
                        const address = new Address();
                        const $address = address._methods._builders.build_address();

                        address._methods._helpers.check_for_default_billing_address('company');
                        address._methods._helpers.listen_to_address_inputs($address);

                        if($wrapper.length > 0)
                            $wrapper.append($address);
                    }
                }catch(e){
                    console.log(e);
                }
            
                show_required();
                initializeTooltips();
            
                const onEvents = [{evt:'blur', type:'password'}, {evt:'focus', type:'text'}];
                onEvents.each((obj) => { // This handles the toggle of hidden cc_number or shown cc_number
                    am.$('.js-validate-cc-number').on(obj.evt, (e) => { 
                        am.$(e.target).attr('type', obj.type); 
                        const $i = am.$(e.target).siblings('i');
                        if($i.length > 0){
                            if(obj.type == 'text' || $i.is(':visible') && am.$(e.target).val() == '')
                                $i.hide();
                            else if($i.is(':hidden') && am.$(e.target).val().length != '')
                                $i.show();
                        }
                    });
                });
                am.$('.js-validate-cc-number').on('keydown', (e) => {
                    var regEx = /^\d+$/;
                    setTimeout(() =>{
                        if(regEx.test(e.target.value) || e.target.value == ''){
                            check_card_type(e);
                        }
                        else{
                            show_error_msg({
                                target: '#cc_num', 
                                msg: get_language_translation('LANG_MSG_NUMBERS_ONLY'), 
                                custom_section: false, 
                                set_focus: true,
                                clearOnKeyDown: true
                            });
                        }
                    }, 100);
                });

                this._methods._helpers.toggle_disabled_btn();

                if(this._debug.build_card_payment)
                    console.log(this, "this");
            },
        } // ----------------------- End - Builders -------------------
    }
}

// --------------- Start External Functions ----------------
function add_new_card(){
    var card = new PaymentMethod();
        card._methods._setters.set_include_address(true);
        card._methods._builders.build_card_payment(false);
}

function payment_msg_check(){
    var msg = localStorage.getItem('payment_success_msg');
    if(msg && msg != ''){
        show_snackbar({
            message: msg,
            type: 'success',
            timer: 4000
        });
        localStorage.removeItem('payment_success_msg');
    }
}

async function add_payment_method(type, url) {
    var validation = new ValidatePage();
        validation.update_page_to_section(am.$('#card_cont')); // set validation container to #card_cont
    var validate = await validation.validate();

    if(validate){
        let card = new PaymentMethod();
        card._methods._setters.set_type(type);
        card._methods._setters.set_url(url);
        card._methods._helpers.update_instance_payment_method();
    }
}

function jump_to_year(e) {
    const $month = am.$(e.target);
    const $year = $month.parent('.dates').children('.js-cc_exp_year');
    
    if($month.val().length == 2 && e.keyCode != 37 )
        $year.focus();
}

function jump_to_month(e){
    const $year = am.$(e.target);
    const $month = $year.parent('.dates').children('.js-cc_exp_month');

    if($year.val().length == 0 && e.keyCode == 8 || e.keyCode == 37)
        $month.focus();
}

function toggle_num(e){
    const $number = am.$(e.target).siblings('input[id="cc_num"]');
    if($number.length > 0)
        $number.focus();
}
// --------------- End External Functions ----------------

